























import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class BulkSendModal extends Vue {

  selected = null

  @Prop({ required: true, type: Array })
  userIds!: number[]

  dialog = false

  emailOptions: any[] | null = null

  get userCount() {
    return this.userIds.length
  }

  get emailSubject() {
    if (!this.selected || !this.emailOptions || !this.emailOptions.length) {
      return '-'
    }

    return (this.emailOptions as any[]).find((e: any) => e.id === this.selected).name
  }

  mounted() {
    axios.get('emails/templates').then((res) => {
      this.emailOptions = res.data.result
    })
  }

  public sendEmail() {
    axios.post('users/bulk-email', { templateId: this.selected, userIds: this.userIds }).then(() => {
      this.$store.dispatch('showSuccess', 'Emails sent!')
      this.selected = null
      this.dialog = false
    }).catch(() => {
      this.$store.dispatch('showError', 'Error sending emails')
    })
  }
}
